import {
  CreateCustomTimeRangeDocument,
  CreateCustomTimeRangeMutationVariables,
  GetCustomTimeRangesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateCustomTimeRange = () => {
  const [createTimeRange, { loading }] = useMutation(CreateCustomTimeRangeDocument, {
    extractorFn: (data) => data.attendanceMutations.bulkCreateAttendanceCustomTimeRange,
  })

  const create = (variables: CreateCustomTimeRangeMutationVariables) => {
    return createTimeRange({
      variables,
      refetchQueries: [GetCustomTimeRangesDocument],
    })
  }

  return {
    loading,
    create,
  }
}
